import { useEffect, useState } from 'react'
import { BiCheck } from 'react-icons/bi'
import { CgFileDocument } from 'react-icons/cg'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Button from '../../components/common/Button/Button.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import { useAuth } from '../../context/auth'
import { useBusinessDetailsForm } from '../../hooks/useBusinessDetailsForm.ts'
import { getLocalAgreement } from '../../utils/agreement/getLocalAgreement.ts'
import { isUserExistsInGroup } from '../../utils/userRights.ts'

const UsagePolicy = ({
  setStep
}: {
  setStep: React.Dispatch<React.SetStateAction<number>>
}) => {
  const navigate = useNavigate()
  const { state } = useAuth()
    const isRestrictedUser = isUserExistsInGroup(
    state.groups,
    'dd_panel_restricted_users'
  )
  const { loading, company } = useBusinessDetailsForm()
  const agreementStep = getLocalAgreement(state.email)
  const initialState = agreementStep
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if (agreementStep !== initialState) {
      setStep(3)
    }
    if (Number(agreementStep) > 2) {
      setIsChecked(true)
    }
  }, [agreementStep])

  const handleShowRegulation = async () => {
    const response = await fetch('/pdfs/d24-usage-policy.pdf')
    if (!response.ok) {
      toast.error('Nie udało się pobrać pliku PDF')
      return
    }
    const blob = await response.blob()
    const fileURL = URL.createObjectURL(blob)

    window.open(fileURL, '_blank')
  }

  const handleAcceptAgreement = async () => {
    if (Number(agreementStep) < 3) {
      localStorage.setItem(
        'agreement-' + state.email,
        JSON.stringify({ user: state.email, step: '3' })
      )
      setStep(3)
    }

    navigate('/account/subscription/')
  }

  const handleOnClick = () => {
    if (isRestrictedUser) {
      Number(agreementStep) > 1 ? setIsChecked(!isChecked) : null
    }
  }

  return (
    <div className={'mt-6'}>
      <Breadcrumbs pageName="Regulamin" breadcrumbs={[]} />
      <div className="text-[20px] text-red-400">
        {agreementStep === '1' ? 'Brak uzupełnionych danych firmowych -' : ''}
        {agreementStep === '1' && (
          <button
            className="px-4 text-[18px] text-blue-500"
            onClick={() => navigate('/account/business-details/')}
          >
            Cofnij
          </button>
        )}
        {!loading && company && (
          <div className=" text-[20px] text-red-400">
            {agreementStep === '2'
              ? 'Proszę zapoznać się z regulaminem korzystania z systemu informatycznego Dietetyk 24 i potwierdzić jego akceptację.'
              : ''}
          </div>
        )}
      </div>
      {!loading && company && (
        <div className="mt-6">
          <Card>
            {loading && <Loader label={'Pobieranie danych...'} />}
            {!loading && (
              <Card.Body>
                <div className={'flex flex-1 items-center pt-6'}>
                  <Button
                    variant="filled"
                    size="medium"
                    color="secondary"
                    className="px-6"
                    disabled={Number(agreementStep) < 2}
                    onClick={() => handleShowRegulation()}
                    icon={<CgFileDocument size={20} />}
                  >
                    {'Pokaż Regulamin'}
                  </Button>

                  <div
                    onClick={handleOnClick}
                    className={
                      'w-[22px] h-[22px] flex items-center justify-center mx-6 border-2 border-gray-400'
                    }
                  >
                    {isChecked && (
                      <BiCheck
                        size={28}
                        className={'text-green-700 scale-150'}
                      />
                    )}
                  </div>
                  <p className={'text-[22px]'}>
                    {
                      'Oświadczam, że akceptuję regulaminem korzystania z systemu informatycznego Dietetyk 24.'
                    }
                  </p>
                </div>
                <Button
                  variant="filled"
                  size="medium"
                  color="primary"
                  className="mt-6"
                  onClick={handleAcceptAgreement}
                  disabled={!isChecked}
                >
                  {'Przejdź dalej'}
                </Button>
              </Card.Body>
            )}
          </Card>
        </div>
      )}
    </div>
  )
}

export default UsagePolicy
